import CustomerKnowledgeBase from "./components/CustomerKnowledgeBase";

export default CustomerKnowledgeBase;
